import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close_icon",
  "use": "icon-close_icon-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close_icon\">\r\n<path d=\"M11.9999 14.7588L21.2276 23.9865L23.9853 21.2288L14.7576 12.0011L23.9853 2.77342L21.2276 0.0157049L11.9999 9.24341L2.77212 0.015625L0.0144043 2.77334L9.24219 12.0011L0.0144043 21.2289L2.77212 23.9866L11.9999 14.7588Z\" fill=\"white\" fill-opacity=\"0.6\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol